import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import {Field, reduxForm, getFormValues} from 'redux-form';
import * as validateRule from '../../validateRule.js';
import Grid from '@mui/material/Grid';
import {connect} from 'react-redux';

import LoginCommon, {commonStyles, renderTextField} from './loginCommon.js';
import {PositiveButton} from '../../atoms/Buttons/PositiveButton.js';
import {renderNoticeArea} from '../../atoms/CustomPart.js';
import {postRequest} from '../../../common/backend.js';
import withRouter from '../../organisms/withRouter.js';
import {commonOperations} from '../../../reducks/common/index.js';
import conf from '../../../config/config.js';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      information: '',
    };
  }
  doLogin = async () => {
    console.log('#######');
    const {
      doShowMessage,
      getLoginInfo,
      loginAction,
      navigate,
    } = this.props;

    const result = await loginAction();
    if (result === 'OK') {
      // ログイン関連情報一括取得
      const userInfo = await getLoginInfo();

      // メニュー画面へ遷移
      if (userInfo) {
        navigate('/menu');
      }
    } else if (result === 'REDIRECT_NEW_PASSWORD') {
      // 仮パスワードログインのため、パスワード変更画面へリダイレクト
      const dialog = {
        message: 'TKSCS00018I',
        action: () => {
          navigate('/changePassword');
        },
      };
      doShowMessage(dialog);
    } else if (result === 'RESET_REQUIRE') {
      const dialog = {
        message: 'TKSCZ00021I',
      };
      doShowMessage(dialog);
    } else if (result === 'NO_LOGIN') {
      const dialog = {
        message: 'TKSCZ00019E',
      };
      doShowMessage(dialog);
    } else {
      const dialog = {
        message: 'TKSCS00001S',
      };
      doShowMessage(dialog);
    }
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    // ログインのインフォメーション取得
    const information = await this.doGetInformation();
    let item = information?.systemSettingsList[0]?.valueString;
    this.setState({
      information: item || '',
    });

    // ConfigにdefaultUserが定義されている場合、初期入力状態にする
    const defaultUser = conf.defaultUser;
    if (defaultUser) {
      const {change} = this.props;
      change('username', defaultUser.id);
      change('password', defaultUser.password);
    }
  };

  /**
   * インフォメーションを取得する
   * @return {Promise<Object>} 検索結果
   */
  doGetInformation = async () => {
    const body = {
      condition: {
        classification: ['2'],
        itemName: 'ログイン',
      },
    };
    const response = await postRequest('common/get-information', body);
    if (response.status != '200') {
      return null;
    }
    return response.data;
  };

  /**
   *パスワードリセット(新パスワード入力)遷移
   */
  doPasswordReset = () => {
    this.props.navigate('/resetPassword');
  };

  render() {
    const {classes, handleSubmit} = this.props;

    return (
      <LoginCommon>
        <Grid container justifyContent="center">
          <div className={classes.noticeTitle}>お知らせ</div>
          {renderNoticeArea(classes.noticeArea, this.state.information)}
          <Grid item xs={8}>
            <Field
              name="username"
              label="ID"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="username"
              type="text"
              validate={[validateRule.required]}
            />
          </Grid>
          <Grid item xs={8}>
            <Field
              name="password"
              label="パスワード"
              type="password"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="current-password"
              validate={[validateRule.required]}
            />
          </Grid>
          <Grid item xs={12}>
            <PositiveButton
              onClick={handleSubmit(this.doLogin)}
              variant="contained"
              className={classes.button}
              size="large"
            >
              <span>ログイン</span>
            </PositiveButton>
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={this.doPasswordReset}
              className={classes.button}>
              <u>パスワードを忘れた方</u>
            </Button>
          </Grid>
          <span className={classes.copyright} style={{margin: '10px 0px 0px 0px'}}>
            Copyright © Chugoku Electric Power Transmission & Distribution
            Co.,Inc. All rights reserved.
          </span>
        </Grid>
      </LoginCommon>
    );
  }
}

const FORM_NAME = 'Login';

Login.propTypes = {
  change: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  doShowMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  loginAction: PropTypes.func,
  getLoginInfo: PropTypes.func,
  navigate: PropTypes.func,
};

const mapDispatchToProps = {
  getLoginInfo: commonOperations.doGetLoginInfo,
};

const mapStateToProps = (state) => ({
});

Login = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Login));
export default withStyles(commonStyles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Login)),
);
